import React, { useCallback, useEffect, useMemo, useReducer, useRef, useState } from 'react';
import {
  EAreaPrefix,
  IParticipantForUser,
  IPartyForUser,
  IPartyStageForUser,
  TAreaKey,
} from '../../PartyClientResponse';
import {
  PartyAreaBackground as PartyAreaPreview,
  TParticipantsByArea,
} from './PartyAreaBackground';
import useResizeObserver from 'use-resize-observer';
import { useAppState } from '../../state/AppState';
import Modal from '../common/Modal';
import { Badge, Button, Form, Input, Switch, Tooltip } from 'antd';
import { IAreaSettings } from '../../PartyClientRequests';
import { joinArea } from '../../controller/client/PartyClient';
import { getAreaInfo, getNextRoomId } from '../../controller/Areas';
import { getIdToken } from '../../controller/PartyDB';
import RoomNameFormItem from '../common/forms/items/RoomNameFormItem';
import { ReactComponent as AddRoomIcon } from './icons/add_room.svg';
// import { gql, useQuery } from '@apollo/client';
// import Gallery from 'react-grid-gallery';
import { useForm } from 'antd/lib/form/Form';
import roomIconMap, { IPartyIconType } from '../party/roomIcons';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import GameModel, {
  GameState,
  gameStateToString,
  GameType,
  gameTypeToString,
} from '../game/models/GameModel';
import GameData from '../game/data/GameData';
import FirestoreService from '../../services/FirestoreService';
import FunctionsService from '../../services/FunctionsService';
import PlayerModel, { CreatePlayerViewModel } from '../game/models/PlayerModel';
import ErrorMessage from '../game/components/ErrorMessage';
import ChallengeGameClient from '../game/ChallengeGameClient';
import GameEventModel from '../game/models/GameEventModel';
import CreateGameViewModel from '../game/models/CreateGameViewModel';
import UserAvatar from '../common/UserAvatar';
import { ProvidedRequiredArgumentsOnDirectivesRule } from 'graphql/validation/rules/ProvidedRequiredArgumentsRule';
import { useGameState } from '../game/GameState';

// const ROOM_ICON_QUERY = gql`
//   query GetAvatars {
//     roomIcons {
//       url
//     }
//   }
// `;
export interface IAppContextState {
  hello: string;
}

// export interface IGameDetailContextState {
//   detail: GameModel;
//   players: PlayerModel[];
//   events: GameEventModel[];
// }

// function gameDetailReducer(state: IGameDetailContextState, action: TGameAction) {
//   switch (action.type) {
//     case GameDetailActionType.SET_GAME_DETAIL:
//       return {
//         ...state,
//         detail: action.detail,
//       };
//     case GameDetailActionType.SET_GAME_PLAYERS:
//       return {
//         ...state,
//         players: action.players,
//       };
//     case GameDetailActionType.SET_GAME_EVENTS:
//       return {
//         ...state,
//         events: action.events,
//       };
//     default:
//       throw new Error();
//   }
// }

const NewAreaModalContent = ({
  party,
  onCancel,
  onSubmit,
}: {
  party: IPartyForUser;
  onCancel: () => void;
  onSubmit: () => void;
}) => {
  const { user } = useAppState();
  const [loading, setLoading] = useState<boolean>(false);
  const [form] = useForm();
  // const [mode, setMode] = useState<'main' | 'select-icon'>('main');
  const [mode] = useState<'main' | 'select-icon'>('main');
  // const { data, loading: roomIconsLoading } = useQuery(ROOM_ICON_QUERY);
  const initialRoomType = EAreaPrefix.ChatPrefix;

  const handleSubmit = useCallback(
    async (values: IAreaSettings) => {
      setLoading(true);
      try {
        await joinArea({
          idToken: await getIdToken(),
          key: party.key,
          area: getNextRoomId(EAreaPrefix.ChatPrefix),
          name: values.name,
          settings: {
            private: values.private || false,
          },
        });
      } catch (e) {
        console.log(e);
      }
      setLoading(false);
      onSubmit();
    },
    [party.key, onSubmit]
  );

  return (
    <>
      <div className='onboarding-card'>
        <h1>create your own room</h1>
        <Form
          style={{ width: '100%' }}
          form={form}
          preserve={false}
          name='values'
          layout='vertical'
          initialValues={{
            roomname: `${user?.displayName}'s Room`,
            roomtype: initialRoomType,
            iconUrl: 'PartyIcon8372',
            private: false,
          }}
          onFinish={(values) => {
            handleSubmit({
              name: values.roomname,
              private: values.private,
            });
          }}>
          {mode === 'select-icon' && (
            <>
              <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%', flexFlow: 'wrap' }}>
                <CarouselProvider
                  naturalSlideWidth={400}
                  naturalSlideHeight={400}
                  visibleSlides={4}
                  totalSlides={Object.values(roomIconMap).length}>
                  <Slider>
                    {Object.entries(roomIconMap).map(
                      (
                        [key, PartyIcon]: [string, IPartyIconType],
                        idx: number,
                        array: [string, IPartyIconType][]
                      ) => {
                        // const Icon = form.getFieldValue('iconUrl');
                        return (
                          <Slide key={key} index={idx}>
                            <PartyIcon style={{ width: 200, height: 200 }} />
                          </Slide>
                          // <div style={{ display: 'flex' }}>
                          //   {/* <CurrentIcon style={{ width: '100%', height: '100%' }} />; */}
                          // </div>
                        );
                      }
                    )}
                  </Slider>
                  <ButtonBack>Back</ButtonBack>
                  <ButtonNext>Next</ButtonNext>
                </CarouselProvider>
              </div>
              {/* <Gallery
                onClickThumbnail={function (val: any) {
                  console.log(form.getFieldsValue());
                  form.setFieldsValue({
                    iconUrl: data.roomIcons[val].url,
                  });
                  setMode('main');
                }}
                images={Object.keys(icons).map((icon: any) => ({
                  src: icon.url,
                  thumbnail: icon.url,
                  thumbnailWidth: 40,
                  thumbnailHeight: 40,
                }))}
              /> */}
            </>
          )}
          <>
            {/* <Form.Item label='Icon' name='iconUrl' valuePropName='children'>
              <img width={100} height={100} alt='Room Icon' />
              <Button style={{ marginLeft: 30 }} onClick={() => setMode('select-icon')}>
                Select icon
              </Button>
            </Form.Item> */}
            <RoomNameFormItem name='roomname' />
            <Form.Item label='Private room?' name='private' valuePropName='checked'>
              <Switch loading={loading} />
            </Form.Item>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button
                disabled={loading}
                type='default'
                size='large'
                onClick={() => onCancel()}
                style={{
                  display: 'inline-flex',
                  width: '30%',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: 80,
                }}>
                cancel
              </Button>
              <Button
                loading={loading}
                size='large'
                type='primary'
                htmlType='submit'
                style={{
                  display: 'inline-flex',
                  width: '68%',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: 80,
                }}>
                create
              </Button>
            </div>
          </>
        </Form>
      </div>
    </>
  );
};

const GameRules = () => {
  return (
    <>
      <div
        className='challenge-box'
        style={{ fontSize: 20, marginBottom: 8, textAlign: 'center', color: '#e45683' }}>
        Challenge!
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          justifyContent: 'space-evenly',
        }}>
        <div className='game-intro'>
          Welcome to the challenge game! This game is defined by yourself and the players.
        </div>
        <div className='game-intro'>
          The challenges are up to the players to think of and the points are awarded by the host
        </div>
      </div>
    </>
  );
};

const ChallengeGameDetails = ({
  currentGame,
  currentAreaParticipants,
  currentGamePlayers,
  currentGameEvents,
  addPoint,
  removePoint,
  startGame,
  endGame,
  isOwner,
  leaveGame,
  createGame,
  clearGameFromRoom,
  setGameDisplayName,
}: {
  currentGame: GameModel | null;
  currentGamePlayers: PlayerModel[];
  currentGameEvents: GameEventModel[];
  currentAreaParticipants: IParticipantForUser[];
  addPoint: (player: PlayerModel) => void;
  removePoint: (player: PlayerModel) => void;
  startGame: () => void;
  endGame: () => void;
  isOwner: boolean;
  leaveGame: () => Promise<void>;
  clearGameFromRoom: () => Promise<void>;
  createGame: () => void;
  setGameDisplayName: (name: string) => Promise<void>;
}) => {
  const [isSettingName, setIsSettingName] = useState<boolean>(false);
  const [displayName, setDisplayName] = useState<string>(currentGame?.displayName || '');
  const { isHost } = useAppState();

  if (!currentGame) {
    return <div>Loading...</div>;
  }

  const playerElements = currentGamePlayers
    .filter((player) => currentAreaParticipants.find((p) => player.foreignReferenceId === p.uid))
    .map((player, i) => {
      const participant = currentAreaParticipants.find((p) => player.foreignReferenceId === p.uid);
      return (
        <div className='' key={player.id}>
          {participant ? (
            <>
              <div>{participant.displayName}</div>
              <div className='game-player-item'>
                <img
                  alt='avatar'
                  className='game-player-avatar'
                  width={40}
                  height={40}
                  src={participant?.photoURL}></img>
                {/* <UserAvatar
                size={SELF_VIDEO_SIZE_PX}
                style={{
                  border: '1px solid #faf7f8',
                  boxShadow: '0px 0px 20px #00000061',
                  // position: 'absolute',
                  width: '100%',
                  height: '100%',
                }}
              /> */}
                <div className='game-player-item-background'>
                  <div style={{ fontSize: 20, marginLeft: 32 }}>{player?.points || 0}</div>
                </div>
              </div>
              {isOwner && (
                <div>
                  <Button
                    onClick={() => {
                      removePoint(player);
                    }}
                    className='cta'
                    style={{}}
                    size='small'>
                    Point (-)
                  </Button>
                  <Button
                    onClick={() => {
                      addPoint(player);
                    }}
                    className='cta'
                    style={{}}
                    size='small'>
                    Point (+)
                  </Button>
                </div>
              )}
            </>
          ) : (
            <div>Player absent...</div>
          )}
        </div>
      );
    });

  const eventElements = currentGameEvents.map((event, i) => (
    <div key={event.id}>
      <ul>
        <li>id: {event.id}</li>
        <li>type: {event.type}</li>
        <li>typeTitle: {event.typeTitle}</li>
      </ul>
    </div>
  ));

  console.log(currentGame.state);

  return (
    <div className='game-details'>
      {/* <ErrorMessage errorCode={gameDetailError}></ErrorMessage> */}
      {currentGame && (
        <>
          {currentGame.state === GameState.STOPPED && (
            <>
              <div style={{ fontSize: 16, marginBottom: 8, textAlign: 'center', color: '#e45683' }}>
                Game complete!
              </div>
              <div style={{ fontSize: 12, marginBottom: 8 }}>
                {!!currentGame.winner &&
                  `The winner is: ${currentGame.winner.foreignReferenceId} with ${currentGame.winner.points}`}
              </div>
              {isOwner && (
                <div style={{ fontSize: 12, textAlign: 'center' }}>
                  <Button
                    onClick={() => {
                      clearGameFromRoom();
                    }}
                    className='cta'
                    style={{}}
                    size='small'>
                    done
                  </Button>
                </div>
              )}
              {!isOwner && (
                <div style={{ fontSize: 12, textAlign: 'center', marginTop: 12 }}>
                  <Button
                    onClick={() => {
                      leaveGame();
                    }}
                    className='cta'
                    style={{}}
                    size='small'>
                    Done
                  </Button>
                </div>
              )}
            </>
          )}
          {currentGame.state === GameState.NONE && (
            <>
              {isOwner && (
                <div className='game-intro-box'>
                  {!isSettingName && (
                    <>
                      <GameRules />
                      <div
                        style={{
                          display: 'flex',
                          flexGrow: 1,
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}>
                        <Button
                          onClick={() => {
                            setIsSettingName(true);
                          }}
                          className='cta'
                          style={{}}
                          size='small'>
                          Continue
                        </Button>
                      </div>
                    </>
                  )}
                  {isSettingName && (
                    <>
                      <div style={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                        <form
                          style={{ textAlign: 'center', width: '100%' }}
                          onSubmit={async (e) => {
                            e.preventDefault();

                            await setGameDisplayName(displayName);
                            startGame();
                          }}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginBottom: 12,
                              fontSize: 16,
                            }}>
                            What is the name of your game!?
                          </div>
                          <Input
                            value={displayName}
                            onChange={(e) => setDisplayName(e.target.value || '')}
                          />
                        </form>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexGrow: 1,
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}>
                        <Button
                          onClick={async () => {
                            await setGameDisplayName(displayName);
                            startGame();
                          }}
                          className='cta'
                          style={{}}
                          size='small'>
                          Let's play!
                        </Button>
                      </div>
                    </>
                  )}
                </div>
              )}
              {!isOwner && (
                <div className='game-intro-box'>
                  <GameRules />
                  <div
                    style={{
                      display: 'flex',
                      flexGrow: 1,
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}>
                    <Button
                      onClick={() => {
                        leaveGame();
                      }}
                      className='cta'
                      style={{}}
                      size='small'>
                      Leave game
                    </Button>
                  </div>
                </div>
              )}
            </>
          )}
          {currentGame.state === GameState.STARTED && (
            <>
              <div
                style={{
                  fontSize: 16,
                  marginBottom: 8,
                  textAlign: 'center',
                  color: '#e45683',
                  fontWeight: 'bold',
                }}>
                Challenge!
              </div>
              {/* <div>Players</div> */}
              <div className='game-player-container'>{playerElements}</div>
              {!isOwner && (
                <div style={{ fontSize: 12, textAlign: 'center', marginTop: 12 }}>
                  <Button
                    onClick={() => {
                      leaveGame();
                    }}
                    className='cta'
                    style={{}}
                    size='small'>
                    Leave game
                  </Button>
                </div>
              )}
              {isOwner && (
                <div style={{ fontSize: 12, textAlign: 'center', marginTop: 12 }}>
                  <Button
                    onClick={() => {
                      endGame();
                    }}
                    className='cta'
                    style={{}}
                    size='small'>
                    Finish game
                  </Button>
                </div>
              )}
            </>
          )}
          {/* <div>
            Events
            {eventElements}
          </div> */}
        </>
      )}
    </div>
  );
};

const OtherAreas = ({
  participantsByArea,
  party,
  stage,
  moveToArea,
  currentParticipantArea,
  currentAreaSize,
}: {
  participantsByArea: TParticipantsByArea;
  party: IPartyForUser;
  stage: IPartyStageForUser;
  moveToArea: (area: TAreaKey) => Promise<void>;
  currentParticipantArea: TAreaKey;
  currentAreaSize: { width: number; height: number; offsetTop: number; offsetLeft: number };
}) => {
  const { participantsByArea: allParticipantsByArea, currentParticipant } = useAppState();
  const {
    isOwner,
    gameDataState,
    gameDataError,
    gameDataDispatch,
    createGame,
    addPoint,
    removePoint,
    startGame,
    endGame,
    leaveGame,
    clearGameFromRoom,
    setGameDisplayName,
  } = useGameState();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);
  const { width = 0, height = 0 } = useResizeObserver<HTMLDivElement>({ ref });

  const currentAreaParticipants = allParticipantsByArea[currentParticipantArea] || [];

  const numAreas = Object.keys(participantsByArea).length;
  const spokeLength = Math.min(width, height) / 3;
  const totRadius = 2 * Math.PI * spokeLength;
  const previewRadius = Math.min(totRadius / numAreas / 2, spokeLength / 2) - 10;
  const totalRadiusSpace = numAreas * previewRadius;

  const totalNumParticipants = Object.values(participantsByArea).reduce(
    (prev, participants) => prev + Math.max(participants.length, 1),
    0
  );
  const allAreas = [...Object.keys(participantsByArea), currentParticipantArea].sort();

  const currentAreaFeatures = getAreaInfo(currentParticipantArea, party);
  const isInGame =
    // !!currentAreaFeatures.currentGameId &&
    !!gameDataState.selectedGamePlayers.find(
      (g) => g.foreignReferenceId === currentParticipant?.uid
    );

  return (
    <div ref={ref} className='other-areas'>
      <div className='other-areas-label'>rooms</div>
      <Modal
        onRequestClose={() => {
          setIsOpen(false);
        }}
        isOpen={isOpen}>
        <NewAreaModalContent
          party={party}
          onSubmit={() => setIsOpen(false)}
          onCancel={() => setIsOpen(false)}
        />
      </Modal>
      <AddRoomIcon className='show-areas-button' style={{ width: '100%', height: '100%' }} />
      <Tooltip
        arrowPointAtCenter
        mouseEnterDelay={1}
        title='click here to create your own room!'
        placement='top'>
        <div
          onClick={() => {
            setIsOpen(true);
          }}
          className='area-background new-area-button clickable-area'
          style={{ width: 2 * previewRadius, height: 2 * previewRadius }}>
          <AddRoomIcon style={{ width: '100%', height: '100%' }} />
          {/* <img alt='Area icon' width='100%' height='100%' src='/icons/add_room.svg' /> */}
        </div>
      </Tooltip>
      {isInGame && (
        <ChallengeGameDetails
          currentGame={
            !!currentAreaFeatures.currentGameId ? gameDataState.selectedGameDetail : null
          }
          currentGameEvents={gameDataState.selectedGameEvents}
          currentGamePlayers={gameDataState.selectedGamePlayers}
          currentAreaParticipants={currentAreaParticipants}
          addPoint={addPoint}
          removePoint={removePoint}
          startGame={startGame}
          endGame={endGame}
          isOwner={isOwner}
          leaveGame={leaveGame}
          createGame={createGame}
          clearGameFromRoom={clearGameFromRoom}
          setGameDisplayName={setGameDisplayName}
        />
      )}
      {allAreas.map((areaKey, i) => {
        const participantsInArea = (participantsByArea[areaKey] || []).length || 1;
        const fractionOfSpace = participantsInArea / totalNumParticipants;
        const proposedRadius = fractionOfSpace * totalRadiusSpace;
        const thisCircleRadius =
          proposedRadius > previewRadius
            ? Math.min(proposedRadius, 1.2 * previewRadius)
            : Math.max(proposedRadius, previewRadius * 0.75);
        const index = Object.keys(participantsByArea).indexOf(areaKey);
        const iAngle = (Math.PI * 2 * index) / (numAreas || 1);
        const areaSizeFactor = thisCircleRadius / previewRadius;
        const left = spokeLength * Math.cos(iAngle) + width / 2 - thisCircleRadius;
        const top = height / 2 - spokeLength * Math.sin(iAngle) - thisCircleRadius;

        let style: React.CSSProperties = {
          left: 0,
          top: 0,
          width: 2 * previewRadius,
          height: 2 * previewRadius,
          opacity: 1,
          transform: `scale(${areaSizeFactor}) translateX(${left / areaSizeFactor}px) translateY(${
            top / areaSizeFactor
          }px)`,
        };

        if (areaKey === currentParticipantArea) {
          style.position = 'absolute';
          style.left = currentAreaSize.offsetLeft - (ref.current?.offsetLeft || 0);
          style.top = currentAreaSize.offsetTop - (ref.current?.offsetTop || 0);
          style.width = currentAreaSize.width;
          style.height = currentAreaSize.height;
          style.transform = 'none';
          style.opacity = 0.4;
        }

        return (
          <PartyAreaPreview
            currentAreaSize={currentAreaSize}
            style={style}
            radius={thisCircleRadius}
            party={party}
            stage={stage}
            key={areaKey}
            areaKey={areaKey as TAreaKey}
            onJoinArea={moveToArea}
            currentParticipants={participantsByArea[areaKey as TAreaKey] || []}
          />
        );
      })}
    </div>
  );
};

export default OtherAreas;
